import { render, staticRenderFns } from "./CarouselVertical.vue?vue&type=template&id=4e1d28f3&scoped=true"
import script from "./CarouselVertical.vue?vue&type=script&lang=js"
export * from "./CarouselVertical.vue?vue&type=script&lang=js"
import style0 from "./CarouselVertical.vue?vue&type=style&index=0&id=4e1d28f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1d28f3",
  null
  
)

export default component.exports